export const enhancer = el => {
  const confirmation = el.getElementsByClassName('gform_confirmation_message');
  if (confirmation.length) {
    window.location.href = `#${confirmation[0].getAttribute('id')}`;
  }
};
